import { useRef } from "react";
import { useNumberField } from "react-aria";
import { NumberFieldStateOptions, useNumberFieldState } from "react-stately";
import { Input } from "./input";
import { cn } from "@/lib/utils";
import { Button } from "./button";

export function NumberField(
  props: Omit<NumberFieldStateOptions, "locale"> & {
    className?: string;
  }
) {
  let state = useNumberFieldState({
    ...props,
    locale: "id-Id",
  });
  let inputRef = useRef<HTMLInputElement>(null);
  let { labelProps, groupProps, inputProps } = useNumberField(
    props,
    state,
    inputRef
  );

  return (
    <div>
      <div {...groupProps} className="flex items-center space-x-2">
        <Input
          {...inputProps}
          ref={inputRef}
          className={cn(
            "text-base font-bold border-theme-gray/20 focus:outline-none focus:border-theme-accent/60",
            inputProps.className
          )}
        />
      </div>
    </div>
  );
}


export function QuantityField(props: Omit<NumberFieldStateOptions, "locale">) {
  let state = useNumberFieldState({ ...props, locale: "id-Id" });
  let inputRef = useRef<HTMLInputElement>(null);
  let { labelProps, groupProps, inputProps } = useNumberField(
    props,
    state,
    inputRef
  );

  return (
    <div>
      <div {...groupProps} className="flex items-center space-x-2">
        <Button
          type="button"
          variant="ghost"
          className="border border-theme-gray/20"
          onClick={state.decrement}
        >
          -
        </Button>
        <Input
          {...inputProps}
          ref={inputRef}
          className="text-center rounded border border-theme-gray/20 w-14"
        />
        <Button
          type="button"
          variant="ghost"
          className="border border-theme-gray/20"
          onClick={state.increment}
        >
          +
        </Button>
      </div>
    </div>
  );
}
